var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavShortlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 811445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3663 22.3633C10.2072 22.3633 10.2072 22.3633 10.0482 22.3633C7.18549 22.3633 4.32279 22.3633 1.46009 22.3633C0.823937 22.3633 0.505859 22.0452 0.505859 21.409C0.505859 18.8644 1.14201 16.4788 2.57336 14.2523C3.68664 12.6619 4.95895 11.5486 6.54934 10.7534C6.54934 10.7534 6.70837 10.7534 6.70837 10.5944C4.95895 9.48114 4.16375 7.89075 4.00471 5.82324C4.00471 4.23285 4.64087 2.8015 5.75414 1.68823C8.13972 -0.538313 11.7976 -0.379274 13.8651 2.00631C16.0917 4.55093 15.6145 8.5269 12.5928 10.5944C13.388 11.0715 14.1832 11.5486 14.8194 12.0258C12.5928 12.6619 10.8434 13.9342 9.88915 16.0017C8.93492 18.2283 9.09396 20.2958 10.3663 22.3633Z",
    fill: "url(#paint0_linear_698_4779)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 16.5012C22.2825 18.7866 21.6868 22.2185 18.7348 24.0905C15.8317 25.9286 12.0427 25.2257 9.97285 22.4892C7.94072 19.8053 8.31774 15.9486 10.8249 13.7158C13.4754 11.359 17.1174 11.6747 19.2814 13.4527C17.8978 15.054 16.5141 16.6553 15.1192 18.2754C14.2822 17.4296 13.4527 16.5914 12.6384 15.7644C11.7637 16.629 10.9154 17.471 10.0784 18.2979C11.8165 20.0458 13.5583 21.8013 15.3227 23.5755C17.3586 21.2111 19.3908 18.858 21.4267 16.5012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 16.5012C22.2825 18.7866 21.6868 22.2185 18.7348 24.0905C15.8317 25.9286 12.0427 25.2257 9.97285 22.4892C7.94072 19.8053 8.31774 15.9486 10.8249 13.7158C13.4754 11.359 17.1174 11.6747 19.2814 13.4527C17.8978 15.054 16.5141 16.6553 15.1192 18.2754C14.2822 17.4296 13.4527 16.5914 12.6384 15.7644C11.7637 16.629 10.9154 17.471 10.0784 18.2979C11.8165 20.0458 13.5583 21.8013 15.3227 23.5755C17.3586 21.2111 19.3908 18.858 21.4267 16.5012Z",
    fill: "url(#paint1_linear_698_4779)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 16.5012C22.2825 18.7866 21.6868 22.2185 18.7348 24.0905C15.8317 25.9286 12.0427 25.2257 9.97285 22.4892C7.94072 19.8053 8.31774 15.9486 10.8249 13.7158C13.4754 11.359 17.1174 11.6747 19.2814 13.4527C17.8978 15.054 16.5141 16.6553 15.1192 18.2754C14.2822 17.4296 13.4527 16.5914 12.6384 15.7644C11.7637 16.629 10.9154 17.471 10.0784 18.2979C11.8165 20.0458 13.5583 21.8013 15.3227 23.5755C17.3586 21.2111 19.3908 18.858 21.4267 16.5012Z",
    fill: "url(#paint2_linear_698_4779)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.271 22.2411C13.9552 20.9179 12.6583 19.6098 11.3613 18.3017C11.7685 17.9108 12.187 17.5011 12.6243 17.0801C13.4349 17.907 14.2832 18.7641 15.1428 19.6399C18.8301 15.366 22.4758 11.1447 26.1292 6.9122C26.5853 7.30313 27.0302 7.68654 27.494 8.08498C23.4184 12.8024 19.3541 17.5124 15.271 22.2411Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.271 22.2411C13.9552 20.9179 12.6583 19.6098 11.3613 18.3017C11.7685 17.9108 12.187 17.5011 12.6243 17.0801C13.4349 17.907 14.2832 18.7641 15.1428 19.6399C18.8301 15.366 22.4758 11.1447 26.1292 6.9122C26.5853 7.30313 27.0302 7.68654 27.494 8.08498C23.4184 12.8024 19.3541 17.5124 15.271 22.2411Z",
    fill: "#33CC00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4779",
    x1: 0.505859,
    y1: 11.2727,
    x2: 15.3346,
    y2: 11.2727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_4779",
    x1: 8.64706,
    y1: 18.5017,
    x2: 21.8153,
    y2: 18.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_4779",
    x1: 8.64706,
    y1: 18.5017,
    x2: 21.8153,
    y2: 18.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavShortlist);
export default __webpack_public_path__ + "static/media/sidenav_shortlist.cb9b85aa78a021c0db7dfcdc792717ee.svg";
export { ForwardRef as ReactComponent };